import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface PasswordGateProps {
  onSuccess: () => void;
}
export function PasswordGate({
  onSuccess
}: PasswordGateProps) {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'hariom') {
      setError(false);
      if (name.trim()) {
        sessionStorage.setItem('gemma_user_name', name.trim());
      }
      onSuccess();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };
  return <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gemma-cream relative overflow-hidden" data-id="element-107">
      {/* Angelic Entry Flash */}
      <motion.div className="fixed inset-0 z-[100] bg-white pointer-events-none flex items-center justify-center" initial={{
      opacity: 1
    }} animate={{
      opacity: 0
    }} transition={{
      duration: 2.5,
      ease: 'easeInOut'
    }} data-id="element-108">
        <div className="w-[800px] h-[800px] bg-[#D4AF37]/10 rounded-full blur-[120px]" data-id="element-109" />
      </motion.div>

      {/* Global Sanctuary Golden Edge Glows */}
      <div className="fixed inset-0 pointer-events-none z-50 shadow-[inset_0_0_120px_rgba(201,166,107,0.1)] mix-blend-overlay" data-id="element-110" />
      <motion.div className="fixed top-[-10%] left-[-10%] w-[50%] h-[40%] bg-gemma-gold/15 blur-[120px] rounded-full pointer-events-none z-0" animate={{
      opacity: [0.4, 0.7, 0.4],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-111" />
      <motion.div className="fixed bottom-[-10%] right-[-10%] w-[60%] h-[50%] bg-gemma-accent/10 blur-[140px] rounded-full pointer-events-none z-0" animate={{
      opacity: [0.3, 0.6, 0.3],
      scale: [1, 1.05, 1]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-112" />

      {/* Golden glow behind the card */}
      <motion.div className="absolute w-[320px] h-[320px] rounded-full bg-gemma-gold/[0.12] blur-[100px] pointer-events-none z-0" animate={{
      opacity: [0.3, 0.6, 0.3],
      scale: [0.95, 1.05, 0.95]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-113" />

      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 1,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} className="w-full max-w-[380px] text-center relative z-10" data-id="element-114">
        {/* Luxe card */}
        <div className="relative rounded-[2.5rem]" data-id="element-115">
          <div className="bg-white/40 backdrop-blur-3xl rounded-[2.5rem] px-10 py-14 relative border border-white/50 shadow-[0_8px_32px_-4px_rgba(44,42,40,0.08),0_2px_8px_-2px_rgba(44,42,40,0.04),inset_0_1px_0_rgba(255,255,255,0.6),inset_0_-1px_0_rgba(255,255,255,0.2)]" data-id="element-116">
            {/* Subtle inner top highlight */}
            <div className="absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-white/60 to-transparent" data-id="element-117" />

            {/* Logo */}
            <motion.div className="relative w-36 mx-auto mb-10" initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.3,
            ease: 'easeOut'
          }} data-id="element-118">
              {/* Logo golden pulse */}
              <motion.div className="absolute inset-0 bg-gemma-gold/20 rounded-full blur-[30px] pointer-events-none" animate={{
              opacity: [0, 0.6, 0],
              scale: [0.8, 1.4, 1.1]
            }} transition={{
              duration: 3,
              ease: 'easeOut',
              delay: 0.5
            }} data-id="element-119" />
              <img src="https://cdn.magicpatterns.com/uploads/6P876MdW2e6yyiu2j7SBPC/logo_gemmamama_transparent.png" alt="Gemma Mama logo" className="w-full h-auto opacity-80 mix-blend-multiply object-contain relative z-10" style={{
              filter: 'sepia(0.8) saturate(1.5) brightness(0.8) contrast(1.2) hue-rotate(350deg)'
            }} data-id="element-120" />
              {/* Diamond Sparkles */}
              <motion.div className="absolute top-2 right-4 w-5 h-5 pointer-events-none z-20" initial={{
              opacity: 0,
              scale: 0,
              rotate: -45
            }} animate={{
              opacity: [0, 1, 0],
              scale: [0, 1.2, 0],
              rotate: 45
            }} transition={{
              duration: 2,
              ease: 'easeInOut',
              delay: 1
            }} data-id="element-121">
                <div className="absolute inset-0 bg-white rounded-full blur-[3px] opacity-80" data-id="element-122" />
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full text-white/90" data-id="element-123">
                  <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-124" />
                </svg>
              </motion.div>
              <motion.div className="absolute bottom-6 left-2 w-4 h-4 pointer-events-none z-20" initial={{
              opacity: 0,
              scale: 0,
              rotate: -45
            }} animate={{
              opacity: [0, 0.8, 0],
              scale: [0, 1, 0],
              rotate: 45
            }} transition={{
              duration: 2,
              ease: 'easeInOut',
              delay: 2.5
            }} data-id="element-125">
                <div className="absolute inset-0 bg-white rounded-full blur-[2px] opacity-80" data-id="element-126" />
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full text-white/80" data-id="element-127">
                  <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-128" />
                </svg>
              </motion.div>
              <motion.div className="absolute top-1/2 -right-1 w-3 h-3 pointer-events-none z-20" initial={{
              opacity: 0,
              scale: 0,
              rotate: -45
            }} animate={{
              opacity: [0, 0.9, 0],
              scale: [0, 1.1, 0],
              rotate: 45
            }} transition={{
              duration: 1.8,
              ease: 'easeInOut',
              delay: 4
            }} data-id="element-129">
                <div className="absolute inset-0 bg-white rounded-full blur-[2px] opacity-80" data-id="element-130" />
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 w-full h-full text-white/90" data-id="element-131">
                  <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-132" />
                </svg>
              </motion.div>
            </motion.div>

            {/* Ornamental divider */}
            <motion.div className="flex items-center justify-center gap-3 mb-8" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} data-id="element-133">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-gemma-accent/55" data-id="element-134" />
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" className="text-gemma-accent/55 shrink-0" data-id="element-135">
                <path d="M12 0C12 0 12 10 24 12C24 12 12 14 12 24C12 24 12 14 0 12C0 12 12 10 12 0Z" fill="currentColor" data-id="element-136" />
              </svg>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-gemma-accent/55" data-id="element-137" />
            </motion.div>

            {/* Headline */}
            <motion.div className="space-y-4 mb-10" initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.45,
            ease: [0.25, 0.46, 0.45, 0.94]
          }} data-id="element-138">
              <h2 className="font-serif text-[28px] text-gemma-charcoal leading-tight tracking-[-0.01em]" data-id="element-139">
                Welcome to your
                <br data-id="element-140" />
                <span className="italic font-normal relative inline-block" style={{
                background: 'linear-gradient(135deg, #B87333, #C4956A, #B87333)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }} data-id="element-141">
                  Sanctuary
                </span>
              </h2>
              <p className="text-gemma-charcoal/55 font-sans font-light text-[12px] leading-relaxed max-w-[220px] mx-auto tracking-wide" data-id="element-142">
                Enter your password to unlock
                <br data-id="element-143" />
                your personal audio collection.
              </p>
            </motion.div>

            {/* Form */}
            <motion.form onSubmit={handleSubmit} className="relative max-w-[240px] mx-auto flex flex-col gap-5 group" initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94]
          }} data-id="element-144">
              <div className="relative" data-id="element-145">
                <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Your Name" className="w-full bg-white/40 border border-gemma-accent/15 text-gemma-charcoal placeholder:text-gemma-charcoal/25 focus:border-gemma-accent/40 focus:bg-white/60 focus:shadow-[0_0_20px_rgba(201,166,107,0.08)] py-3.5 px-5 focus:outline-none transition-all duration-500 font-sans text-center tracking-[0.15em] text-[13px] rounded-2xl" data-id="element-146" />
                <span className="absolute -top-2 left-5 text-[9px] tracking-[0.2em] uppercase text-gemma-charcoal/30 font-sans bg-gemma-cream/80 px-1.5" data-id="element-147">
                  optional
                </span>
              </div>

              <div className="relative" data-id="element-148">
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="• • • • • •" className={`w-full border py-3.5 px-5 pr-12 focus:outline-none transition-all duration-500 font-sans text-center tracking-[0.35em] text-[15px] rounded-2xl ${error ? 'bg-red-50/50 border-red-300/50 text-red-500 placeholder:text-red-300/50' : 'bg-white/40 border-gemma-accent/15 text-gemma-charcoal placeholder:text-gemma-charcoal/20 focus:border-gemma-accent/40 focus:bg-white/60 focus:shadow-[0_0_20px_rgba(201,166,107,0.08)]'}`} data-id="element-149" />
                <motion.button type="submit" whileTap={{
                scale: 0.9
              }} className={`absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-500 ${password.length > 0 ? 'bg-gemma-accent/10 text-gemma-accent opacity-100' : 'text-gemma-charcoal/20 opacity-0 group-hover:opacity-60'}`} aria-label="Submit password" data-id="element-150">
                  <ArrowRight className="w-4 h-4" data-id="element-151" />
                </motion.button>
              </div>

              {/* Enter button for luxe feel */}
              <motion.button type="submit" whileTap={{
              scale: 0.97
            }} whileHover={{
              scale: 1.01
            }} className={`mt-2 py-3 rounded-2xl font-sans text-[11px] tracking-[0.25em] uppercase transition-all duration-500 ${password.length > 0 ? 'bg-gemma-charcoal text-gemma-cream shadow-[0_4px_20px_-4px_rgba(44,42,40,0.25)]' : 'bg-gemma-charcoal/5 text-gemma-charcoal/30 cursor-default'}`} disabled={password.length === 0} data-id="element-152">
                Enter Sanctuary
              </motion.button>
            </motion.form>

            {error && <motion.p initial={{
            opacity: 0,
            y: 4
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-red-400/80 text-[11px] mt-5 font-sans tracking-wide" data-id="element-153">
                Incorrect password. Please try again.
              </motion.p>}

            {/* Bottom ornamental accent */}
            <motion.div className="flex items-center justify-center gap-2 mt-12 opacity-30" initial={{
            opacity: 0
          }} animate={{
            opacity: 0.3
          }} transition={{
            duration: 1,
            delay: 1
          }} data-id="element-154">
              <div className="h-px w-6 bg-gemma-accent/60" data-id="element-155" />
              <div className="w-1 h-1 rounded-full bg-gemma-accent/60" data-id="element-156" />
              <div className="h-px w-6 bg-gemma-accent/60" data-id="element-157" />
            </motion.div>
          </div>
        </div>
      </motion.div>
    </div>;
}